/* eslint @typescript-eslint/no-var-requires: "off" */
const { Autoplay, Navigation } = require('swiper/modules');

export const swiperConfig = {
  modules: [Autoplay, Navigation],
  navigation: true,
  spaceBetween: 50,
  slidesPerView: 1,
  allowTouchMove: false,
  freeMode: true,
  autoplay: {
    delay: 6000,
    disableOnInteraction: true,
  },
  speed: 800,
};

export const CARD_ANIMATION_DURATION = 65; //progress bar will be loaded in 6500ms - this is the duration of image block animation
